<template>
  <div
    class="hrTimesheets-consultant-card non-selectable manager-ts-timesheet-card"
    @click="onManagerTimesheetCardClick"
  >
    <div class="hrTimesheets-card-content">
      <div class="hrTimesheets-main-header">
        <div class="hrTimesheets-header-left">
          <div class="hrTimesheets-header-info">
            <div class="hrTimesheets-label-row">
              <div class="hrTimesheets-main-label">Consultant timesheet</div>
              <div class="hrTimesheets-header-right manager-ts-card-badges">
                <span class="hrTimesheets-status-badge" :class="statusBadgeClass(sheet.status, 'consultant')">
                  {{ sheet.status }}
                </span>
                <span
                  v-if="sheet.billStatus"
                  class="hrTimesheets-status-badge hrTimesheets-status-badge--bill"
                  :class="billBadgeClass(sheet.billStatus)"
                >
                  Bill: {{ sheet.billStatus }}
                </span>
              </div>
            </div>
            <div class="hrTimesheets-main-value">ID {{ sheet.id }}</div>
            <div v-if="sheet.hrTimesheetId" class="hrTimesheets-secondary-info">
              <span class="hrTimesheets-secondary-value">HR ref: {{ sheet.hrTimesheetId }}</span>
            </div>
          </div>
        </div>
      </div>
      <ManagerTimesheetCardDetails :sheet="sheet" />
      <ManagerTimesheetCardAttachments
        :attachments="sheet.attachments"
        list-source="consultant"
        @open-stored="(att) => $emit('open-attachment', { attachment: att, sheet })"
      />
    </div>
    <div class="manager-ts-card-actions">
      <button
        type="button"
        class="hrTimesheets-fetch-btn manager-ts-edit-card-btn"
        @click.stop="$emit('edit', sheet)"
      >
        <i class="bi bi-pencil-square"></i>
        <span>Edit</span>
      </button>
    </div>
  </div>
</template>

<script>
import { statusBadgeClass, billBadgeClass } from '../utils/managerTimesheetCardHelpers';
import ManagerTimesheetCardDetails from './ManagerTimesheetCardDetails.vue';
import ManagerTimesheetCardAttachments from './ManagerTimesheetCardAttachments.vue';
import '@/modules/consultant/styles/HRTimesheets.css';
import '../styles/ManagerTimesheetCardShell.css';

export default {
  name: 'ManagerConsultantTimesheetCard',
  components: {
    ManagerTimesheetCardDetails,
    ManagerTimesheetCardAttachments
  },
  props: {
    sheet: {
      type: Object,
      required: true
    },
  },
  emits: ['edit', 'open-attachment'],
  methods: {
    statusBadgeClass,
    billBadgeClass,
    onManagerTimesheetCardClick(event) {
      const el = event.target;
      if (el.closest('.manager-ts-card-actions')) return;
      if (el.closest('.manager-ts-attachments')) return;
      if (el.closest('button, a')) return;
      this.$emit('edit', this.sheet);
    }
  }
};
</script>
